import { useSelector } from "react-redux";
import style from "./CloseIcon.module.scss";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";

export default function ({ isOpenDeleteBox, deleteContent }: { isOpenDeleteBox: boolean; deleteContent: () => void }) {
  const imagicaStudioTutorial = useSelector((state: any) => state.fot.imagicaStudioTutorial);

  const clickCloseIcon = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    deleteContent();
  };

  return isOpenDeleteBox && !imagicaStudioTutorial.showGuide ? (
    <div className={style["delete-content"]} onClick={clickCloseIcon} data-testid="textnode-delete">
      <img src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Cross.svg`}></img>
    </div>
  ) : null;
}
